// BlockRenderer.tsx
import React from "react";
import ComponentErrorBoundary from "@danishagro/shared/src/components/molecules/ErrorBoundary/ComponentErrorBoundary.component";
import { useBlockDataMapping } from "@danishagro/sharedShop/src/hooks/useBlockDataMapping.hook";
import { BLOCK_MAP } from "./blocksMap.helper";

interface BlockData {
    alias: string;
    key: string;
    version?: string;
    props: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface BlockRendererProps {
    block: BlockData;
}

const BlockRenderer: React.FC<BlockRendererProps> = ({ block }) => {
    // Cast block to any when checking for a 'content' property
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dataForMapping = (block as any).content
        ? block
        : { ...block, content: { props: block.props } };

    const mappedProps = useBlockDataMapping(block.alias, dataForMapping);

    const Component = BLOCK_MAP[block.alias as keyof typeof BLOCK_MAP];

    if (!Component) return null;

    return (
        <ComponentErrorBoundary key={block.key} componentName={block.alias}>
            <Component {...mappedProps} version={block.version} />
        </ComponentErrorBoundary>
    );
};

export default BlockRenderer;
